var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OfMultiSelect',{attrs:{"name":_vm.name,"label":_vm.label,"options":_vm.productSpecificationOptions,"multiple":_vm.multiple},on:{"input":function($event){return _vm.$emit('specificationInput', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }